(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/system-summary.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/system-summary.js');

'use strict';

svs.numbergames.game.views.SystemSummary = Marionette.View.extend({
  regions: {
    headerRegion: '#sytemRowHeaderRegion',
    ballRowRegion: '#sytemBallRowRegion'
  },
  modelEvents: {
    'change:rowPriceMulti': 'changeRowPriceMulti'
  },
  template: data => svs.numbergames.game.templates.system_summary(data),
  onRender() {
    const model = this.model.get('boards').getActive();
    this.showChildView('headerRegion', new svs.numbergames.game.views.BoardDescription({
      model,
      tagName: 'h3',
      className: 'number-games-system-summary-title f-600',
      template: data => svs.numbergames.rules.system.systemDescription({
        rowCount: data.rowCount,
        level: data.level,
        numbersLength: data.numbers.length,
        numbersExtraLength: data.numbersExtra ? data.numbersExtra.length : 0
      })
    }));
    this.showChildView('ballRowRegion', new svs.numbergames.game.views.SystemRow({
      ballRowSize: this.getOption('ballRowSize'),
      model,
      multipliedRowPrice: this.model.get('rowPrice') * this.model.get('rowPriceMulti')
    }));
  },
  changeRowPriceMulti() {
    const multipliedRowPrice = this.model.get('rowPrice') * this.model.get('rowPriceMulti');
    this.getChildView('ballRowRegion').triggerMethod('updateMultipliedRowPrice', multipliedRowPrice);
  }
});

 })(window);